// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1ePy8","header":"Messages_header__5V8zx"};